var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "insure_number_check" },
    [
      _c(
        "el-card",
        { staticClass: "insure_number_content", attrs: { header: "校验工号" } },
        [
          _c("el-alert", {
            attrs: {
              closable: false,
              title: "为了确保您后续业绩统计正确，请确认您的出单工号！",
              type: "warning",
            },
          }),
          _c(
            "div",
            { staticStyle: { "margin-top": "15px" } },
            [
              _c("avue-form", {
                attrs: { option: _vm.InsureNumberOption },
                on: { submit: _vm.onInsureNumber },
                model: {
                  value: _vm.InsureNumberData,
                  callback: function ($$v) {
                    _vm.InsureNumberData = $$v
                  },
                  expression: "InsureNumberData",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }